export const SET_HEADERS = "SET_HEADERS";
export const SET_ROW_HEADERS = "SET_ROW_HEADERS";
export const SET_TYPES = "SET_TYPES";
export const SET_ROW_TYPES = "SET_ROW_TYPES";
export const SET_CATEGORY = "SET_CATEGORY";
export const SET_DROPDOWN_OPTIONS = "SET_DROPDOWN_OPTIONS";
